import { useQuery } from "@tanstack/react-query";
import integrationRepository from "@/repository/integrationRepository";
import { integrationQueryKeys } from "./keys";
import { ScenarioPublish } from "@/model";


const getData = async (scenarioId: string) => {
    const res = await integrationRepository.read(scenarioId);
    return res.data;
};

export const useIntegration = (scenarioId: string) => {
    return useQuery<ScenarioPublish>({
        queryKey: integrationQueryKeys.read(scenarioId),
        queryFn: async () => getData(scenarioId)
    });
};
